<template>
  <div class="bd">
    <!-- 出库 -->
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:'+screenHeight">
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>今日产出物出库：2321Kg</div>
          </div>
          <div style="text-align: right">
            <el-date-picker
              v-model="valueLeftTop"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
            >
            </el-date-picker>
          </div>
          <div class="left-list-title" style="height: auto">
            <div class="list-item">
              <div>名称</div>
              <div>重量（Kg）</div>
            </div>
          </div>
          <div class="left-list" style="position: relative">
            <div class="list-item">
              <div>冰箱碎铜块</div>
              <div>207</div>
            </div>

            <div class="list-item">
              <div>铜管</div>
              <div>315</div>
            </div>

            <div class="list-item">
              <div>冰箱碎铝材</div>
              <div>123</div>
            </div>

            <div class="list-item">
              <div>压铁块</div>
              <div>426621</div>
            </div>

            <div class="list-item">
              <div>杂铁材</div>
              <div>236</div>
            </div>

            <div class="list-item">
              <div>加热管</div>
              <div>168</div>
            </div>

            <div class="list-item">
              <div>锌块</div>
              <div>201</div>
            </div>

            <div class="list-item">
              <div>洗衣机白pp</div>
              <div>123</div>
            </div>

            <div class="list-item">
              <div>电视ps</div>
              <div>435</div>
            </div>

            <div class="list-item">
              <div>空调ps</div>
              <div>453</div>
            </div>

            <div class="list-item">
              <div>电视白ps</div>
              <div>126</div>
            </div>

            <div class="list-item">
              <div>液晶电视ps</div>
              <div>511</div>
            </div>

            <div class="list-item">
              <div>空调白ps</div>
              <div>341</div>
            </div>

            <div class="list-item">
              <div>空调增强ps</div>
              <div>234</div>
            </div>

            <div class="list-item">
              <div>冰箱碎铜块</div>
              <div>207</div>
            </div>

            <div class="list-item">
              <div>铜管</div>
              <div>315</div>
            </div>

            <div class="list-item">
              <div>冰箱碎铝材</div>
              <div>123</div>
            </div>

            <div class="list-item">
              <div>压铁块</div>
              <div>426621</div>
            </div>

            <div class="list-item">
              <div>杂铁材</div>
              <div>236</div>
            </div>

            <div class="list-item">
              <div>加热管</div>
              <div>168</div>
            </div>

            <div class="list-item">
              <div>锌块</div>
              <div>201</div>
            </div>

            <div class="list-item">
              <div>洗衣机白pp</div>
              <div>123</div>
            </div>

            <div class="list-item">
              <div>电视ps</div>
              <div>435</div>
            </div>

            <div class="list-item">
              <div>空调ps</div>
              <div>453</div>
            </div>

            <div class="list-item">
              <div>电视白ps</div>
              <div>126</div>
            </div>

            <div class="list-item">
              <div>液晶电视ps</div>
              <div>511</div>
            </div>

            <div class="list-item">
              <div>空调白ps</div>
              <div>341</div>
            </div>

            <div class="list-item">
              <div>空调增强ps</div>
              <div>234</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
      valueLeftTop: ["2023-01-03", "2023-01-20"],
    };
  },
  mounted() {},
  methods: {},
};
</script>
  <style scoped>
::-webkit-scrollbar {
  width: 0px;
}

.main .left,
.main .right {
  width: 21.5vw;
  height: 75vh;
  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
}
.main .right {
  float: right;
  margin-right: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main .left .left-content .left-list {
  height: 55vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

.left-list-title{
  margin-top: 20px;
}
.left-list-title .list-item {
  display: flex;
  align-items: center;
}
.left-list-title .list-item div {
  width: 50%;
  padding: 15px 0;
  text-align: center;
  border-bottom: 1px #fff solid;
}
.left-list .list-item {
  display: flex;
  align-items: center;
}
.left-list .list-item div {
  width: 50%;
  padding: 15px 0;
  text-align: center;
  border-bottom: 1px #fff solid;
}
::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
</style>
  